import axios from 'axios';
import { registerMaintenanceInterceptor } from '../common/maintenance';
import Config from '../config';
import apiClient from '../ui/form.builder/FBApi/FBApi.client';

const apiXClient = (authorization: string, isApiPublic?: boolean) => {
  const createAdapter: any = require('mobx-rest-axios-adapter').default;
  // The adapter loses the status code when it rejects, so 491 has to be caught
  // on the axios instance it wraps.
  registerMaintenanceInterceptor(axios);
  apiClient(
    createAdapter(axios), {
      apiPath: isApiPublic ? Config.PublicUrl : Config.ApiEndpoint,
      commonOptions: {
        headers: {
          Authorization: isApiPublic ? '' : authorization,
        },
      },
    });
};

export default apiXClient;
